import EventActionProto from '../event-action-proto';
import ApiSession from "../../gd/api/session";

module.exports = class EventCompanyRoleChange extends EventActionProto {

    constructor(uid, data, fromSID, companyId) {
        super(uid, data, companyId);
    }

    process() {
        if (this.companyId === gd.companyId) {
            // someone changed current user role in company (!)
            const sessionResetRequest = ApiSession.fullReset(gd.companyId);
        }
    }
};
